import { useEffect, useState } from 'react'

export interface ScreenDimensions {
  width: number,
  height: number,
}

const withScreenResize = () => {
  const [ size, setSize ] = useState<ScreenDimensions>({
    width: 0,
    height: 0,
  })
  useEffect(() => {
    const handler = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      })
    }
    window.addEventListener('resize', handler)
    handler()
    return () => window.removeEventListener('resize', handler)
  }, [])
  return size
}

export default withScreenResize